import "../../components/sections/broker-review-slide-section/broker-review-slide-section"
import "../../components/sections/dev-project-slide-section/dev-project-slide-section"
import "../../components/sections/estates-slide-section/estates-slide-section"
import "../../components/sections/re-agency-detail-branches-section/re-agency-detail-branches-section"
import "../../components/sections/estate-detail-intro-section/estates-detail-intro-section"
import "../../components/sections/fade-in-section/fade-in-section"
